export default "__VITE_ASSET__D2fEvZsL__"